<template>
    <div class="admin-options mt-page">

          <data-form
              :title="$i18n.gt('LABEL_OPTIONS')"
              :save-button-label="$i18n.gt('LABEL_SAVE')"
              :field-model="optionFields"
              :field-groups="[fieldGroups]"
              :load-model-instance="loadModelInstance"
              :on-submit-handler="onSubmit"
              :submit-success-message="$i18n.gt('LABEL_OPTION_UPDATED')"
              :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_OPTION')"
              submit-success-route="/"
              cancel-route="/">
          </data-form>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'
import OptionFields from '../models/Option'

/**
 * Page to manage super admins
 */
export default Vue.extend({
    name: 'AdminOptions',
    data() {
        return {
            options: null,
            optionFields: OptionFields,
        }
    },
    computed: {
        fieldGroups() {
            return Object.keys(this.optionFields.fields)
        },
    },
    methods: {
        async loadModelInstance() {
            return this.$api.getAllItems(this, 'option')
                .then(options => {
                    this.options = options
                    // convert to object for editing
                    let modelInstance = {}
                    _.forEach(options, option => {
                      modelInstance[option.name] = option.value
                    })
                    return modelInstance
                })
        },
        async onSubmit(data) {
            // find changes
            const fieldGroups = this.fieldGroups
            for (let field of this.fieldGroups) {
                // get entered value
                if (data && (data[field] !== undefined)) {
                    let value = data[field] || ''
                    // find option
                    let option = _.find(this.options, option => (option.name === field))
                    if (!option && value.length) {
                        // create new option record
                        let record = {
                            name: field,
                            value: value
                        }
                        this.$api.createItem(this, 'option', record, false)
                            .then(response => {
                                this.$toasted.show('Option created', {duration: 3000})
                            })
                            .catch(error => {
                                console.log('AdminOptions:onSubmit  error=', error)
                            })
                    } else if (option && (option.value !== value)) {
                        // update option record
                        option.value = value
                        this.$api.updateItem(this, 'option', option, false)
                            .then(response => {
                                this.$toasted.show('Option created', {duration: 3000})
                            })
                            .catch(error => {
                                console.log('AdminOptions:onSubmit  error=', error)
                            })
                    }
                }
            }
          // // this.$v.form.$touch()
          //   if (this.$v.form.$anyError) {
          //       return
          //   } else {
          //       Validation.extractFormModel(this.$v.form, this.fieldModel, this.modelInstance, this.fieldList)
          //       try {
          //           await this.Handler(this.modelInstance)
          //           if (this.submitSuccessMessage) {
          //               this.$toasted.show(this.submitSuccessMessage, {duration: 3000})
          //           }
          //           if (this.submitSuccessRoute) {
          //               this.$router.push(this.submitSuccessRoute)
          //           }
          //       } catch (e) {
          //           if (this.submitErrorMessage) {
          //               this.$utils.handleError(e, this.submitErrorMessage)
          //           } else {
          //               this.$utils.handleError(e, 'Form submission error')
          //           }
          //       }
          //   }
        },
    }
})

</script>
